import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAirModal } from "@air/provider-modal";
import { useShortIdContext } from "@air/provider-short-id";
import { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { usePublicPageViewNotification } from "~/components/AirNotifications/hooks/usePublicPageViewNotification";
import { BoardCollectionUploadsManager } from "~/components/BoardCollection/BoardCollectionUploadsManager";
import { BoardCollectionViewWrapper } from "~/components/BoardCollection/BoardCollectionViewWrapper";
import { useAlertOnUnsubmittedCCForm } from "~/components/BoardCollection/hooks/useAlertOnUnsubmittedCCForm";
import { ContentCollectionAnonymousSignUpModal } from "~/components/PublicLinkAnonymousSignUpModal/ContentCollectionAnonymousSignUpModal";
import { ROOT_ELEMENT_ID } from "~/hooks/useMouseSelection";
import { useOnMissingUserSession } from "~/hooks/useOnMissingUserSession";
import { useAccountContext } from "~/providers/AccountProvider";
import { boardCollectionFormSelector, boardCollectionHasClipsSelector } from "~/store/boardCollection/selectors";
import { BoardCollectionActionBar } from "./BoardCollectionActionBar";
import { BoardCollectionDropzone } from "./BoardCollectionDropzone";
import { BoardCollectionHero } from "./BoardCollectionHero";
export const BoardCollectionWrapper = /*#__PURE__*/ memo((param)=>{
    let { requireAccount } = param;
    const form = useSelector(boardCollectionFormSelector);
    const { shortId } = useShortIdContext();
    const hasClips = useSelector(boardCollectionHasClipsSelector);
    const scrollElementRef = useRef(null);
    const { data: account } = useAccountContext();
    const [showAnonymousSignupModal] = useAirModal(ContentCollectionAnonymousSignUpModal);
    const { sendPublicPageViewEvent } = usePublicPageViewNotification();
    useOnMissingUserSession({
        onMissingSession: ()=>showAnonymousSignupModal({}),
        enabled: requireAccount
    });
    useEffect(()=>{
        if (!requireAccount || requireAccount && !!account) {
            sendPublicPageViewEvent(shortId);
        }
    }, [
        account,
        requireAccount,
        sendPublicPageViewEvent,
        shortId
    ]);
    useAlertOnUnsubmittedCCForm();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BoardCollectionDropzone, {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex h-full flex-col bg-grey-3",
                    id: ROOT_ELEMENT_ID,
                    /**
           * @TODO remove this when content collection has been converted to dark mode
           */ "data-theme": "light",
                    children: [
                        (form === null || form === void 0 ? void 0 : form.workspace) && /*#__PURE__*/ _jsx(BoardCollectionHero, {
                            account: account,
                            workspace: form.workspace
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex-1 overflow-y-auto",
                            id: "main",
                            ref: scrollElementRef,
                            children: /*#__PURE__*/ _jsx(BoardCollectionViewWrapper, {
                                scrollElementRef: scrollElementRef,
                                isEmpty: !hasClips
                            })
                        }),
                        hasClips && /*#__PURE__*/ _jsx("div", {
                            className: "inset-x-0 bottom-0 z-1",
                            children: /*#__PURE__*/ _jsx(BoardCollectionActionBar, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(BoardCollectionUploadsManager, {})
        ]
    });
});
BoardCollectionWrapper.displayName = "BoardCollectionWrapper";
